import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { replace } from 'react-router-redux';
import qs from 'qs';
import { flashErrorMessage } from '../../../actions/flash';
import { fetchM } from '../../../actions/fetchM';
import isNumber from '../../../utils/numbers/isNumber';
import { checkChanges } from '../../../utils/checkChanges';

import Overview from './Overview';
import Edit from './Edit';
import Pictures from './Pictures/List';
import Documents from './Documents/List';
import Videos from './Videos/List';

export default class UnitLayout extends Component {
  static propTypes = {
    params: PropTypes.shape({
      id: PropTypes.string,
      unitLayoutID: PropTypes.string,
    }),
    children: PropTypes.node,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static Overview = checkChanges(Overview)
  static Edit = checkChanges(Edit)
  static Pictures = Pictures
  static Documents = Documents
  static Videos = Videos

  constructor(props) {
    super(props);
    this.state = {
      token: null,
      pictureToken: null,
      documentToken: null,
      mediaToken: null,
      count: 0,
      limit: 0,
      offset: 0,
      loading: true,
      data: null,
      documents: [],
    };
  }
  componentDidMount() {
    const { pathname, query } = this.props.location;
    this.fetchProjectUnitLayout();
    if (!pathname.includes('/edit/')) {
      if (pathname.includes('/pictures/')) {
        this.fetchProjectUnitLayoutPictures();
      }
      if (pathname.includes('/documents/')) {
        this.fetchProjectUnitLayoutDocuments(query);
      }
      if (pathname.includes('/videos/')) {
        this.fetchProjectUnitLayoutMedias(query);
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    const { pathname, query } = nextProps.location;
    if (!pathname.includes('/edit/')) {
      if (pathname.includes('/pictures/')) {
        this.fetchProjectUnitLayoutPictures();
      } else if (pathname.includes('/documents/')) {
        this.fetchProjectUnitLayoutDocuments(query);
      } else if (pathname.includes('/videos/')) {
        this.fetchProjectUnitLayoutMedias(query);
      } else {
        this.fetchProjectUnitLayout();
      }
    }
  }
  setDocuments(documents = []) {
    return new Promise((res) => {
      this.setState({
        documents: documents || [],
      }, () => {
        res(documents);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchProjectUnitLayout() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.params.id}/unit_layouts/${this.props.params.unitLayoutID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      // handle token.. etc
      await this.setComponentState({
        token,
        data,
      });
    }
    await this.setLoading(false);
  }
  async fetchProjectUnitLayoutPictures() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.params.id}/unit_layouts/${this.props.params.unitLayoutID}/pictures/?page=1`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const pictureToken = res.headers.get('X-Csrf-Token');
      // handle token.. etc
      await this.setComponentState({
        pictureToken,
      });
    }
    await this.setLoading(false);
  }
  async fetchProjectUnitLayoutDocuments(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.params.id}/unit_layouts/${this.props.params.unitLayoutID}/documents/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const documentToken = res.headers.get('X-Csrf-Token');
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const documents = await res.json();
      await this.setDocuments(documents);
      if (this.state.documents.length < 1 && query.page > 1) {
        query.page = 1;
        store.dispatch(replace(`/projects/${this.props.params.id}/layouts/${this.props.params.unitLayoutID}/documents/?${qs.stringify(query)}`));
      }
      // handle token.. etc
      await this.setComponentState({
        documentToken,
        count,
        limit,
        offset,
      });
    }
    await this.setLoading(false);
  }
  async fetchProjectUnitLayoutMedias() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.params.id}/unit_layouts/${this.props.params.unitLayoutID}/medias/?page=1`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const mediaToken = res.headers.get('X-Csrf-Token');
      // handle token.. etc
      await this.setComponentState({
        mediaToken,
      });
    }
    await this.setLoading(false);
  }
  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child, {
        token: this.state.token,
        pictureToken: this.state.pictureToken,
        documentToken: this.state.documentToken,
        mediaToken: this.state.mediaToken,
        count: this.state.count,
        limit: this.state.limit,
        offset: this.state.offset,
        loading: this.state.loading,
        data: this.state.data,
        documents: this.state.documents,
        id: this.props.params.id,
        unitLayoutID: this.props.params.unitLayoutID,
      })
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Project/UnitLayout/UnitLayout.jsx